export default __webpack_public_path__ + "static/media/tagline.0d71356f.png";